import selectric from 'selectric';
import 'selectric/public/selectric.css';
const filters = {
    init() {

        if($('#category-select')[0]){

        if ($(window).width() > 768) {
              $('#category-select').selectric({
                  onChange: (element) => {
                      this.filterPosts($(element).val());
                  }
              });
          }else{
            $('#category-select').selectric();
              $('#category-select').on('change', function(){
                  var value = $(this).val();  // Get the value of the selected option
                  filterPostsv2(value);

              })

            function filterPostsv2(category_id) {
                // AJAX request to filter posts based on the selected category
                $.ajax({
                    url: ajax_params.ajax_url, // Ensure ajax_params is defined and ajax_url is correct
                    type: 'POST',
                    data: {
                        action: 'filter_posts',
                        category_id: category_id
                    },
                    success: (response) => {
                        $('.post-results').empty();
                        $('.videos-results').empty();
                        if (response.posts.length) {
                            response.posts.forEach(function(post) {
                                var postHTML = '<div class="grid-12 post-outer">' +
                                    '<div class="post-item">' +
                                    '<span class="title">' +
                                    '<h3>' + post.title + '</h3>' +
                                    '<span class="date text--primary">' + post.post_date + '</span>' +
                                    '</span>' +
                                    '<a href="' + post.link + '" class="button button--primary-alt button--small">Read</a>' +
                                    '</div>' +
                                    '</div>';

                                $('.post-results').append(postHTML);
                            });
                        }else{
                            var postHTML = '<div class="grid-12 post-outer text--center"><p>No posts found</p></div>';
                            $('.post-results').append(postHTML);
                        }

                        if (response.videos.length) {
                            console.log(response.videos)
                            response.videos.forEach(function(video) {
                                var videoHTML = '<div class="grid-12 grid-md-4">' +
                                    '<a href="' + video.video + '" class="video-link" data-fancybox>' +
                                    '<div class="video">' +
                                    '<div class="video-wrapper">' +
                                    '<video width="100%" muted>' +
                                    '<source src="' + video.video + '" type="video/mp4">' +
                                    'Your browser does not support the video tag.' +
                                    '</video>' +
                                    '<div class="video-title">' +
                                    '<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">' +
                                    '<circle cx="20" cy="20" r="20" fill="#F7F7F7"/>' +
                                    '<path d="M15 23.1015V17.5354C15 14.3443 15 12.7488 16.0305 12.1777C17.0609 11.6065 18.4139 12.4522 21.12 14.1435L25.5728 16.9265C28.0085 18.4488 29.2264 19.21 29.2264 20.3185C29.2264 21.4269 28.0085 22.1881 25.5728 23.7104L21.12 26.4935C18.4139 28.1847 17.0609 29.0304 16.0305 28.4592C15 27.8881 15 26.2926 15 23.1015Z" fill="#151826"/>' +
                                    '</svg>' +
                                    '<h3>' + video.title + '</h3>' +
                                    '</div>' +
                                    '</div>' +
                                    '</div>' +
                                    '</a>' +
                                    '</div>';

                                $('.videos-results').append(videoHTML);
                            });
                        }else{
                            var postHTML = '<div class="grid-12 post-outer text--center"><p>No videos found</p></div>';
                            $('.post-results').append(postHTML);
                        }
                        $('.load-more-block').toggle(response.load_more_posts);
                        $('.load-more-block-video').toggle(response.load_more_videos);
                    }
                });
            }

          }



        }

        // Correct 'this' context with arrow function
        $('.category-filter').click((event) => {
            const category_id = $(event.currentTarget).data('category');  // Ensure your categories have data-category attributes
            $('.category-filter').removeClass('active');
            $(event.currentTarget).addClass('active');
            this.filterPosts(category_id);
        });



        var ajaxurl = '/wp-admin/admin-ajax.php';
        var page = 2;
        $('body').on('click', '.load-more-block button', function() {
            var button = $(this);
            var data = {
                'action': 'load_more',
                'query': ajax_params.query_vars,
                'page' : page
            };

            $.ajax({
                url : ajaxurl,
                data : data,
                type : 'POST',
                beforeSend : function ( xhr ) {
                    button.text('Loading...');
                },
                success : function( data ){
                    if( data ) {
                        button.text('Load more');
                        $('.post-results').append(data)
                        page++;
                    } else {
                        button.text('No more posts');
                    }
                }
            });
            return false;
        });
        $('body').on('click', '.load-more-block-video button', function() {
            var button = $(this);
            var data = {
                'action': 'load_more',
                'query': ajax_params.query_vars,
                'page' : page,
                'video': true,
                'post_type': 'video',
            };

            $.ajax({
                url : ajaxurl,
                data : data,
                type : 'POST',
                beforeSend : function ( xhr ) {
                    button.text('Loading...');
                },
                success : function( data ){
                    console.log(data);
                    if( data ) {
                        button.text('Load more');
                        $('.videos-results').append(data)
                        page++;
                    } else {
                        button.text('No more posts');
                    }
                }
            });
            return false;
        });


    },
    filterPosts(category_id) {
        // AJAX request to filter posts based on the selected category
        $.ajax({
            url: ajax_params.ajax_url, // Ensure ajax_params is defined and ajax_url is correct
            type: 'POST',
            data: {
                action: 'filter_posts',
                category_id: category_id
            },
            success: (response) => {
                $('.post-results').empty();
                $('.videos-results').empty();
                if (response.posts.length) {
                    response.posts.forEach(function(post) {
                        var postHTML = '<div class="grid-12 post-outer">' +
                            '<div class="post-item">' +
                            '<span class="title">' +
                            '<h3>' + post.title + '</h3>' +
                            '<span class="date text--primary">' + post.post_date + '</span>' +
                            '</span>' +
                            '<a href="' + post.link + '" class="button button--primary-alt button--small">Read</a>' +
                            '</div>' +
                            '</div>';

                        $('.post-results').append(postHTML);
                    });
                }else{
                    var postHTML = '<div class="grid-12 post-outer text--center"><p>No posts found</p></div>';
                    $('.post-results').append(postHTML);
                }

                if (response.videos.length) {
                    response.videos.forEach(function(video) {
                        var videoHTML = '<div class="grid-12 grid-md-4">' +
                            '<a href="' + video.video + '" class="video-link" data-fancybox>' +
                            '<div class="video">' +
                            '<div class="video-wrapper">' +
                            '<video width="100%">' +
                            '<source src="' + video.video + '" type="video/mp4">' +
                            'Your browser does not support the video tag.' +
                            '</video>' +
                            '<div class="video-title">' +
                            '<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">' +
                            '<circle cx="20" cy="20" r="20" fill="#F7F7F7"/>' +
                            '<path d="M15 23.1015V17.5354C15 14.3443 15 12.7488 16.0305 12.1777C17.0609 11.6065 18.4139 12.4522 21.12 14.1435L25.5728 16.9265C28.0085 18.4488 29.2264 19.21 29.2264 20.3185C29.2264 21.4269 28.0085 22.1881 25.5728 23.7104L21.12 26.4935C18.4139 28.1847 17.0609 29.0304 16.0305 28.4592C15 27.8881 15 26.2926 15 23.1015Z" fill="#151826"/>' +
                            '</svg>' +
                            '<h3>' + video.title + '</h3>' +
                            '</div>' +
                            '</div>' +
                            '</div>' +
                            '</a>' +
                            '</div>';

                        $('.videos-results').append(videoHTML);
                    });
                }else{
                    var postHTML = '<div class="grid-12 post-outer text--center"><p>No videos found</p></div>';
                    $('.post-results').append(postHTML);
                }
                $('.load-more-block').toggle(response.load_more_posts);
                $('.load-more-block-video').toggle(response.load_more_videos);
            }
        });
    },
}
export {filters}